export default __webpack_public_path__ + "static/media/Snd42.4783698a.mp3";